module.exports = __webpack_public_path__ + "img/brand-cases9.4e55accf.png";